import { useState } from 'react';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
  width: '100%',
  maxWidth: 400,
};

const labelStyle = {
  fontSize: 18,
  color: 'rgba(255,255,255,0.9)',
  fontFamily: "'League Spartan', Arial, sans-serif",
  textAlign: 'center',
};

const textareaStyle = {
  width: '100%',
  minHeight: 100,
  padding: '12px 16px',
  borderRadius: 12,
  border: 'none',
  background: 'rgba(255,255,255,0.15)',
  color: '#fff',
  fontFamily: "'League Spartan', Arial, sans-serif",
  fontSize: 16,
  resize: 'vertical',
  outline: 'none',
};

const rowStyle = {
  display: 'flex',
  gap: 12,
};

const btnPrimary = {
  padding: '12px 28px',
  fontSize: 17,
  fontFamily: "'League Spartan', Arial, sans-serif",
  fontWeight: 700,
  color: '#55B4BE',
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: 100,
  cursor: 'pointer',
};

const btnSkip = {
  ...btnPrimary,
  background: 'transparent',
  color: 'rgba(255,255,255,0.5)',
  fontSize: 15,
};

export default function OpenFeedback({ onSubmit }) {
  const [text, setText] = useState('');

  return (
    <div style={containerStyle}>
      <span style={labelStyle}>
        Este produto está em constante evolução. Poderia deixar algum feedback?
      </span>
      <textarea
        style={textareaStyle}
        placeholder="Achou algum problema?"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <div style={rowStyle}>
        <button type="button" style={btnSkip} onClick={() => onSubmit(null)}>
          Pular
        </button>
        <button type="button" style={btnPrimary} onClick={() => onSubmit(text || null)}>
          Enviar →
        </button>
      </div>
    </div>
  );
}
